// import Cookies from 'js-cookie'

const TokenKey = 'zh-token'

export function getToken() {
    return localStorage.getItem(TokenKey);
}

export function setToken(token) {
    return localStorage.setItem(TokenKey, token)
}

export function removeToken() {
    return localStorage.removeItem(TokenKey)
}

export function getUserId() {
    return localStorage.getItem('userId');
}

export function getUserInfo() {
    let userInfo = localStorage.getItem('userInfo');
    return userInfo ? JSON.parse(userInfo) : {};
}

export function getAuthInfo() {
    let authInfo = localStorage.getItem('authInfo');
    return authInfo ? JSON.parse(authInfo) : {};
}

export function getConfig() {
    let config = localStorage.getItem('publicConfig');
    return config ? JSON.parse(config) : null;
}

export function setConfig(config) {
    config = JSON.stringify(config);
    return localStorage.setItem('publicConfig',config);
}